import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M18.56 3.93a4.94 4.94 0 1 0 0 9.88 4.5 4.5 0 0 0 1.11-.14.26.26 0 0 1 .26.1.24.24 0 0 1 .07.23 6.83 6.83 0 0 1-5.88 3.52 1.25 1.25 0 1 0 0 2.5 9.71 9.71 0 0 0 9.43-9.94V8.87a5 5 0 0 0-4.99-4.94m-12.32 0a4.94 4.94 0 1 0 0 9.88 4.6 4.6 0 0 0 1.11-.14.26.26 0 0 1 .26.1.24.24 0 0 1 0 .27 6.84 6.84 0 0 1-5.88 3.52 1.25 1.25 0 0 0 0 2.5 9.71 9.71 0 0 0 9.43-9.94V8.87a5 5 0 0 0-4.92-4.94"
    }, null, -1)
  ]));
}
const interfaceTextFormattingRightCloseQuote = { render };
export {
  interfaceTextFormattingRightCloseQuote as default,
  render
};
//# sourceMappingURL=interface-text-formatting-right-close-quote.svg.js.map
